<div class="container">
  <div class="imageContainer">
    <img
      class="mt-5"
      height="50"
      width="50"
      alt="selected bank logo"
      [src]="selectedBank.logo"
    />
    <p class="imageText text-center">
      {{ "webauth_waiting_login_to_external_bank" | translate }}
      {{ selectedBank.name }}
    </p>
  </div>

  <div class="spinningContainer">
    <app-lottie-loader [height]="'50px'" [color]="'BLACK'"></app-lottie-loader>
    <p class="spinningText">
      {{ "webauth_please_authenticate_to_external_bank" | translate }}
    </p>
  </div>
</div>

<button (click)="backToBankChoice()" class="mt-5 btn bg-gray rounded-full px-5" type="button">
  {{ 'common_cancel' | translate }}
</button>

<span class="text-dimgray mt-2 font-14 font-md-15">
  {{ "common_abandonAndGoBackBankChoice" | translate }}
</span>
